import { render, staticRenderFns } from "./ProductMetadata.vue?vue&type=template&id=3ebe293a&scoped=true&"
import script from "./ProductMetadata.vue?vue&type=script&lang=js&"
export * from "./ProductMetadata.vue?vue&type=script&lang=js&"
import style0 from "./ProductMetadata.vue?vue&type=style&index=0&id=3ebe293a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe293a",
  null
  
)

export default component.exports